import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function AuntysBeachHouseOpen() {
  const dateTexts = ['2011年', '頃'];
  const dateAdditionalInfo = 'アンティーズビーチハウスの時代設定は現代であるため、' +
    'ストーリー上の時代も、施設が実際にオープンした2011年頃であると考えられる。'
  const title = 'アンティーズビーチハウス オープン';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2020/09/Aulani2.jpg'
  const description = (
    <>
      {'ハワイに'}
      <a href='/auntys-beach-house'>
        {'アンティーズビーチハウス'}
      </a>
      {'がオープンする。'}
      {'ここにはかつて'}
      <a href='/adventurers-club'>
        {'アドベンチャラーズクラブ'}
      </a>
      {'に在籍していた「カイミ」が住んでおり、彼のコレクションが数多く飾られている。'}
    </>
  );
  const quoteDomain = 'mainstreettales.com';

  return (
    <EventCard
      dateTexts={dateTexts}
      dateAdditionalInfo={dateAdditionalInfo}
      title={title}
      description={description}
      imgUrl={imgUrl}
      quoteDomain={quoteDomain}
    />
  );
}

export default AuntysBeachHouseOpen;
